export * from './projekt-arts.service';
export * from './projekt-arts.service.module';